import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Text, View, Platform, StyleSheet } from 'react-native';

import Theme from '../theme';
import { showError } from '../ui';
import { Logger } from '../utils/Logger';
import { UserDataConsumer } from '../utils';
import { showToastMessage } from '../ui/redux/uiActions';
import { PrivacyList } from './components';
import { partnerUnblocked } from '../ui/components/Toast';
import { Styles } from './components';

class BlockedPartners extends Component {
    state = {
        isLoading: false,
    };

    // TODO: Move this higher up for all error handling
    handelError = (error, caller = '') => {
        const { user: { userProfile } } = this.props; 
        console.log('error', error);
        showError(error.message);
        Logger.notify(error, (report) => {
            report.errorClass = 'WorkoutPartners';
            let userDetails = '';
            if (userProfile) {
                userDetails = `User details:\n
                    id:${userProfile.uid},
                    email:${userProfile.email},
                    name:${userProfile.fullname}`;
            }
            report.errorMessage = `Caller: ${caller}\n\nuserDetails: ${userDetails}`;
        });
    }

    setIsLoading = (isLoading) => {
        this.setState({ isLoading });
    }

    unblock = async (partner) => {
        const { user: { userProfileService: { unblockFromBlacklist } }, showToastMessage } = this.props;
        try {
            this.setIsLoading(true);
            await unblockFromBlacklist(partner.uid);
            showToastMessage(partnerUnblocked(partner.fullname))
        } catch (error) {
            this.handelError(error, 'unblock');
        } finally {
            this.setIsLoading(false);
        }
    }

    render() {
        const { isLoading } = this.state;
        const {
            t,
            user: {
                userProfile: {
                    partnerBlacklist = [],
                    privateProfile = false,
                },
            }
        } = this.props;
        
        let appliedPartnerInfoStyle = styles;
        if (Platform.OS === 'web') {
            appliedPartnerInfoStyle = invertColorStyles;
        }
        return (
            <View style={styles.container}>
                <View style={ appliedPartnerInfoStyle.partnerInfoContainer}> 
                    <Text style={[Styles.header, appliedPartnerInfoStyle.partnerInfo]}>{t('blockedPartnersInfo')}</Text>
                </View>
                <PrivacyList
                    t={t}
                    invertColours
                    listType='blacklist'
                    isLoading={isLoading}
                    unblock={this.unblock}
                    isPrivate={privateProfile}
                    privacyPartnerList={partnerBlacklist}
                />
            </View>
        );
    }
}

const invertColorStyles = StyleSheet.create({
    partnerInfoContainer:{
        borderColor: Theme.GREY_MEDIUM,
        borderWidth: 0.5,
        borderTopWidth:0,
        borderLeftWidth:0,
        borderRightWidth:0,
    },
    partnerInfo: {
        color: Theme.WHITE,
    },
});

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingBottom: 10,
        paddingHorizontal: 15,
    },
    partnerInfo: {
        color: Theme.GREY_MEDIUM,
        // fontWeight:'400',
        fontFamily:Theme.Custom400,
        paddingVertical: 15,
    },
    partnerInfoContainer:{
        borderColor: Theme.CHARCOAL,
        borderWidth: 0.5,
        borderTopWidth:0,
        borderLeftWidth:0,
        borderRightWidth:0,
    },
});

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        showToastMessage: (toast) => dispatch(showToastMessage(toast)),
    }
}

BlockedPartners = connect(state => state, mapDispatchToProps)(BlockedPartners)
BlockedPartners = translate(['workoutPartners'], { wait: true })(BlockedPartners);
export default UserDataConsumer(BlockedPartners);
